import axios from "@/axios";
import apiUrl from "@/axios/config";
const home = {
  // customer
  async home(params = "") {
    return await axios.post("/uc/index/data", params, {
      des: "直客pc机构客户数据",
      sTime: new Date().getTime()
    });
  },
  // customer
  async getAccoutMarginFree(params = "") {
    return await axios.post("/uc/getAccoutMarginFree", params, {
      des: "直客pc获取首页金额信息",
      sTime: new Date().getTime()
    });
  },
  // banner
  async getBannerApi(params = "") {
    return await axios.post("/api/services/app/Banner/Banners", params, {
      baseUrl: apiUrl.NEW_APIS,
      des: "直客pc获取banner",
      sTime: new Date().getTime()
    });
  },

  getServer() {
    return axios.post(
      "/customer/list",
      {},
      {
        des: "获取客服链接",
        sTime: new Date().getTime()
      }
    );
  }
};

export default home;



// WEBPACK FOOTER //
// ./src/api/home.js